<template>
    <v-row no-gutters class="contact-teaser">
        <v-col class="content">
            <typo name="title-30-normal">
                {{ dico.title }}
            </typo>
            <sep name="S" />
            <typo name="title-18-bold">
                {{ dico.subtitle }}
            </typo>
            <sep name="M"></sep>
            <typo name="body-16-light">
                {{ dico.text }}
            </typo>
            <sep name="L" />
        </v-col>
        <v-col class="cover"> </v-col>
    </v-row>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    computed: {
        dico() {
            return this.$publicDico.contact.teaser;
        },
    },
});
</script>

<style lang="sass" scoped>
.contact-teaser
   +gt(900)
        min-height: 360px
        display: flex

.cover
    background: url(src/assets/images/teaser-contact.jpg)
    background-size: cover
    background-position: center
    position: relative
    +gt(900)
        flex-basis: 40%
    +gt(1024)
        flex-basis: 50%
    +r(900)
        display: none
    &:after
        position: absolute
        content: ""
        width: 100%
        height: 100%
        background-color: rgba(0, 0, 0, 0.23)
        left: 0
        top: 0

.content
    flex-basis: 100%
    padding: 32px
    box-sizing: border-box
    background-color: $color-background
    +gt(900)
        flex-basis: 60%
    +gt(1024)
        flex-basis: 50%
    +paddingContainer()
</style>
